import styled from 'styled-components'
import { Separator } from '../../styles'

export const Section = styled.div`
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  /* Children should be Header, AttributeList or AttributeColumns */
  & > * {
    padding-left: 20px;
    padding-right: 20px;
  }

  ${Separator} {
    margin-right: 0;
  }
`
